const config = {
    'https://apcoa.de': {
        logo: require ('@/assets/images/default-logo.png'),
        impressum: 'https://www.apcoa.de/ueber-apcoa/unternehmen/impressum/',
        datenschutz: 'https://www.apcoa.de/datenschutzerklaerung/',
        companyName: 'APCOA Deutschland GmbH',
        faqURL: 'faq',
        violationText1 : 'Die Park&Control PAC Switzerland GmbH wird immer dann beauftragt, wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden etc. zur Verfügung stehen, wenn diese Stellplätze beispielsweise durch unberechtigte Fremd- und Dauerparker blockiert werden. Für diese Parkflächen gelten die Nutzungsbedingungen der Park&Control PAC Switzerland GmbH. Anhand dieser prüft die Park&Control PAC Switzerland GmbH, ob eine Berechtigung zum Parken des jeweiligen Fahrzeuges (z.B. in Form einer Gratisparkzeit oder einer sonstigen Parkberechtigung) vorliegt. Ist dies nicht der Fall, stellt die Park&Control PAC Switzerland GmbH auf der rechtlichen Grundlage der jeweils vor Ort aushängenden Nutzungsbedingungen eine Vertragsstrafe aus.',
        violationText2 : 'Die Park&Control PAC Switzerland GmbH wird immer dann beauftragt, wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden etc. zur Verfügung stehen, wenn diese Stellplätze beispielsweise durch unberechtigte Fremd- und Dauerparker blockiert werden. Für diese Parkflächen gelten die Nutzungsbedingungen der Park&Control PAC Switzerland GmbH. Anhand dieser prüft die Park&Control PAC Switzerland GmbH, ob eine Berechtigung zum Parken des jeweiligen Fahrzeuges (z.B. in Form einer Gratisparkzeit oder einer sonstigen Parkberechtigung) vorliegt. Ist dies nicht der Fall, stellt die Park&Control PAC Switzerland GmbH auf der rechtlichen Grundlage der jeweils vor Ort aushängenden Nutzungsbedingungen eine Vertragsstrafe aus.',
        currency: '€',
        bankDetails :{
            companyName: 'APCOA Deutschland GmbH',
            companyIban: 'IBAN',
            companyBic: 'BIC'
        }
    },
    'https://ticket.apcoa.de': {
        logo: require ('@/assets/images/default-logo.png'),
        impressum: 'https://www.apcoa.de/ueber-apcoa/unternehmen/impressum/',
        datenschutz: 'https://www.apcoa.de/datenschutzerklaerung/',
        companyName: 'APCOA Deutschland GmbH',
        faqURL: 'faq',
        violationText1 : 'Die Park&Control PAC Switzerland GmbH wird immer dann beauftragt, wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden etc. zur Verfügung stehen, wenn diese Stellplätze beispielsweise durch unberechtigte Fremd- und Dauerparker blockiert werden. Für diese Parkflächen gelten die Nutzungsbedingungen der Park&Control PAC Switzerland GmbH. Anhand dieser prüft die Park&Control PAC Switzerland GmbH, ob eine Berechtigung zum Parken des jeweiligen Fahrzeuges (z.B. in Form einer Gratisparkzeit oder einer sonstigen Parkberechtigung) vorliegt. Ist dies nicht der Fall, stellt die Park&Control PAC Switzerland GmbH auf der rechtlichen Grundlage der jeweils vor Ort aushängenden Nutzungsbedingungen eine Vertragsstrafe aus.',
        violationText2 : 'Die Park&Control PAC Switzerland GmbH wird immer dann beauftragt, wenn auf privaten Parkflächen nicht genügend Stellplätze für Kunden etc. zur Verfügung stehen, wenn diese Stellplätze beispielsweise durch unberechtigte Fremd- und Dauerparker blockiert werden. Für diese Parkflächen gelten die Nutzungsbedingungen der Park&Control PAC Switzerland GmbH. Anhand dieser prüft die Park&Control PAC Switzerland GmbH, ob eine Berechtigung zum Parken des jeweiligen Fahrzeuges (z.B. in Form einer Gratisparkzeit oder einer sonstigen Parkberechtigung) vorliegt. Ist dies nicht der Fall, stellt die Park&Control PAC Switzerland GmbH auf der rechtlichen Grundlage der jeweils vor Ort aushängenden Nutzungsbedingungen eine Vertragsstrafe aus.',
        currency: '€',
        bankDetails :{
            companyName: 'APCOA Deutschland GmbH',
            companyIban: 'IBAN',
            companyBic: 'BIC'
        }
    },
     'https://portal.park-control.ch': {
        logo: require('@/assets/images/default-logo.png'),
        loginImage: require('@/assets/images/background-image-small.png'),
        locale: ['de', 'fr', 'it'],
        // impressum: 'https://www.park-control.ch/impressum',
        // datenschutz: 'https://www.park-control.ch/datenschutz',
        impressumUrl : {
            de: 'https://www.park-control.ch/impressum',
            fr: 'https://www.park-control.ch/fr/impressums',
            it: 'https://www.park-control.ch/it/impressum',
        },
        datenschutzUrl: {
            de: 'https://www.park-control.ch/datenschutz',
            fr: 'https://www.park-control.ch/fr/protection-des-donnees',
            it: 'https://www.park-control.ch/it/protezione-dei-dati',
        },
        companyName: 'Park & Control PAC Switzerland GmbH',
        faqURL: {
            de: 'https://www.park-control.ch/fragen-zu-vertragsstrafen',
            fr: 'https://www.park-control.ch/fragen-zu-vertragsstrafen',
            it: 'https://www.park-control.ch/fragen-zu-vertragsstrafen',
        },
        currency: 'CHF',
        bankDetails: {
            companyName: 'Park & Control PAC Switzerland GmbH',
            companyIban: 'CH130028728785999902C',
            companyBic: 'UBSWCHZH80A',
        },
    },
    'https://portal.park-control.at': {
        logo: require('@/assets/images/default-logo.png'),
        loginImage: require('@/assets/images/background-image-small.png'),
        locale: ['de', 'en'],
        // impressum: 'https://www.park-control.at/impressum',
        // datenschutz: 'https://www.park-control.at/datenschutz',
        impressumUrl : {
            de: 'https://www.park-control.at/impressum',
            en: 'https://www.park-control.at/impressum',
        },
        datenschutzUrl: {
            de: 'https://www.park-control.at/datenschutz',
            en: 'https://www.park-control.at/datenschutz'
        },
        companyName: 'Park & Control PAC Austria GmbH',
        faqURL: {
            de: 'https://www.park-control.at/fragen-zu-vertragsstrafen',
            en: 'https://www.park-control.at/fragen-zu-vertragsstrafen',
        },
        currency: '€',
        bankDetails: {
            companyName: 'Park & Control PAC Austria GmbH',
            companyIban: 'AT723225000002007862',
            companyBic: 'UBSWCHZH80A',
        },
    },
    'https://ticket.apcoa.at': {
        logo: require('@/assets/images/apc_logo.png'),
        loginImage: require('@/assets/images/apc-bg.jpg'),
        locale: ['de', 'en'],
        // impressum: 'https://www.apcoa.at/impressum',
        // datenschutz: 'https://www.apcoa.at/datenschutz',
        impressumUrl : {
            de: 'https://www.apcoa.at/impressum',
            en: 'https://www.apcoa.at/en/impressum/',
        },
        datenschutzUrl: {
            de: 'https://www.apcoa.at/datenschutz',
            en: 'https://www.apcoa.at/en/datenschutz'
        },
        companyName: 'APCOA Austria GmbH',
        faqURL: {
            de: 'https://www.apcoa.at/faq/',
            en: 'https://www.apcoa.at/en/faqs/',
        },
        currency: '€',
        bankDetails: {
            companyName: 'APCOA Austria GmbH',
            companyIban: 'AT193225000002001444',
            companyBic: 'RLNWATWWGTD',
        },
    },
};

export const getConfig = (domain) => config[domain] || {};

export default config;
